import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';

import { HomeComponent } from './home/home.component';
import { AvisoLegalComponent } from './aviso-legal/aviso-legal.component';
import { PPrivacidadComponent } from './p-privacidad/p-privacidad.component';
import { CookiesComponent } from './cookies/cookies.component';


const routes: Routes = [
  { 
    path: '',
    component: HomeComponent,
    data: { animation: 'postproduction' }
  },
  { 
    path: 'cookies',
    component: CookiesComponent,
    data: { animation: 'postproduction' }
  },
  { 
    path: 'legal',
    component: AvisoLegalComponent,
    data: { animation: 'postproduction' }
  },
  { 
    path: 'privacidad',
    component: PPrivacidadComponent,
    data: { animation: 'postproduction' }
  },
  { 
    path: '**',
    component: HomeComponent,
    data: { animation: 'postproduction' }
  },
];



@NgModule({
  imports: [RouterModule.forRoot(routes, {scrollPositionRestoration: 'enabled'})],
  exports: [RouterModule]
})
export class AppRoutingModule { }